import React from "react";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link } from 'gatsby'
import Accordion from 'react-bootstrap/Accordion';

const TermHolder = ({data}) => {
  return (

    <div type={data.type} >

        {data.type === 'FAQ' &&
            <div className="accordion-section">
                <div className="accordion-section_wrapper">
                    <h2>{data.title}</h2>
                    <Accordion>
                    {data?.terms && data.terms.map((term, key) =>
                        <Accordion.Item eventKey={key}>
                            <Accordion.Header><h3>{term.title}</h3></Accordion.Header>
                            <Accordion.Body>{ term.definition?.raw && documentToReactComponents(JSON.parse(term.definition.raw))}</Accordion.Body>
                        </Accordion.Item>
                    )}
                    </Accordion>
                </div>
            </div>
        }


        {data.type === "Connectors" && 
            <div className="row-container">
                <div className="row-container_wrapper">
                    <h2>{data.title}</h2>
                    {data.copy.raw && documentToReactComponents(JSON.parse(data.copy.raw))}                    
                    <div className="features-grid horizontal">
                        { data.terms.map((term, key) =>
                            <div className="feature">
                                <div className="icon">
                                    {term.graphic != null &&
                                        <img src={term.graphic.file.url} alt="" />
                                    }
                                </div>
                                <div className="content">  
                                    <h4>{term.title}</h4>
                                    {documentToReactComponents(JSON.parse(term.definition.raw))}
                                    { term.destination != null &&
                                        <Link to={term.destination}>Learn More</Link>
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        }


        { (data.type === "Benefits" && data.terms.length >= 4) &&
            <div className="row-container">
                <div className="row-container_wrapper">
                    <h2>{data.title}</h2>
                    { data.copy?.raw && documentToReactComponents(JSON.parse(data.copy.raw)) } 

                    {
                        data.customClasses == "checkmark-list" &&
                        <ul className="grid-list">
                            { data.terms.map((term) =>
                                <li><strong>{term.title}:</strong> {documentToReactComponents(JSON.parse(term.definition.raw))}</li>
                            )}
                        </ul>
                    }

                    {
                        data.customClasses != "checkmark-list" &&
                        <div className="features-grid">
                            { data.terms.map((term) =>
                                <div className="feature">
                                    <div className="icon">
                                        {term.graphic != null &&
                                            <img src={term.graphic.file.url} alt="" />
                                        }
                                    </div>
                                    <div className="content">  
                                        <h4>{term.title}</h4>
                                        {documentToReactComponents(JSON.parse(term.definition.raw))}
                                        { term.destination != null &&
                                            <Link to={term.destination}>Learn More</Link>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        }


        { (data.type === "Benefits" && data.terms.length <= 3) && 
            <div className="row-container">
                <div className="row-container_wrapper">
                    <h2>{data.title}</h2>
                    { data.copy?.raw && documentToReactComponents(JSON.parse(data.copy.raw)) }                    
                    <div className="three-col-grid">
                        { data.terms.map((term) =>
                            <div className="col-item">
                                <div className="icon">
                                    {term.graphic != null &&
                                        <img src={term.graphic.file.url} alt="" />
                                    }
                                </div>
                                <div className="content">
                                <h4>{term.title}</h4>
                                    {documentToReactComponents(JSON.parse(term.definition.raw))}
                                    { term.destination != null &&
                                        <Link to={term.destination}>Learn More</Link>
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        }
    </div>
  )
}

export default TermHolder
